import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom';
import { CartItem } from './CartItem';
import { YourDetails } from './YourDetails';
import { ReviewCartItem } from './ReviewCartItem';
import { ReviewOrder } from './ReviewOrder';
import { appService } from '../../_services';
import { MakePayment } from './MakePayment';
import { de } from 'date-fns/locale';
import { Redirect } from 'react-router-dom'
import DocumentMeta from 'react-document-meta';

export class ShoppingCart extends Component {
    displayName = ShoppingCart.name
    constructor(props) {
        super(props);
        this.up = this.up.bind(this);
        this.down = this.down.bind(this);

        this.state = {
            key: '1',
            url: [],
            CartItem: [],
            YourDetails: [],
            ReviewCartItem: [],
            ReviewOrder: [],
            totalTax: 0,
            OrderId: 0,
            phoneNo: '',
            

        };
        this.handleSelect = this.handleSelect.bind(this);

    }
    GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }

        }
    }


    componentDidMount() {

        var self = this;
        
        var batchid = this.GetURLParameter("hdncardpayments");
        
        if (batchid != null && batchid != undefined) {
            appService.getAll('Cart/GetOrderIdByBatchId?bid=' + batchid).then(function (response) {
                
                self.setState({
                    OrderId: response,
                    key: 0,
                });
            });

        }

        if (this.state.key == '1') {

            appService.getAll('Cart/ShoppingCart').then(function (response) {

                self.setState({ CartItem: response });
            });
        }
    }

    handleSelect(Activekey) {
        this.setState({ key: Activekey });
        window.scrollTo(0, 0);

        if (Activekey == '1') {
            var self = this;
            appService.getAll('Cart/ShoppingCart').then(function (response) {
                self.setState({ CartItem: response });
            });
        }

        if (Activekey == '3') {
            document.getElementById('controlled-tab-example-tab-3').click();

        }

    }

    up(max) {
        document.getElementById("myNumber").value = parseInt(document.getElementById("myNumber").value, 10) + 1;
        if (document.getElementById("myNumber").value >= parseInt(max, 10)) {
            document.getElementById("myNumber").value = max;
        }
    }
    down(min) {
        document.getElementById("myNumber").value = parseInt(document.getElementById("myNumber").value, 10) - 1;
        if (document.getElementById("myNumber").value <= parseInt(min, 10)) {
            document.getElementById("myNumber").value = min;
        }
    }


    YourDetailsCallback(YourDetails) {

        this.setState({ YourDetails: YourDetails });
    } 
    render() {


        const meta = {
            title: "Kluwer Law Online - Shopping cart",
            //description: "Kluwer Law Online publishes peer-reviewed journals and manuals on various practice areas in international law. Browse within our practice areas to discover which titles we offer in your area of legal practice or on important legal subject-matters.",
            canonical: window.location.href,
            meta: {
                charset: "utf-8",
                name: {
                    keywords: "Shopping cart,Online Shopping,Manuals,practice area in international law,corporate and commercial law, litigation, labour law and transport law"
                }
            }
        }


        
        if (this.state.OrderId != "" && this.state.OrderId != null) {
            return <Redirect to={"/OrderPlaced?OrderId=" + this.state.OrderId.toString() } />
        } 
        else {
            const Title1 = <span style={{ verticalAlign: 'sub' }}> Shopping cart <i className="fa fa-angle-right float-right"></i> </span>
            const Title2 = <span style={{ verticalAlign: 'sub' }}> Your details <i className="fa fa-angle-right float-right"></i> </span>
            const Title3 = <span style={{ verticalAlign: 'sub' }}> Review order <i className="fa fa-angle-right float-right"></i> </span>
            const Title4 = <span style={{ verticalAlign: 'sub' }}> Payment <i className="fa fa-angle-right float-right"></i> </span>

            return (
                <DocumentMeta {...meta}>
                <div className="col-12 klo-shopping-cart" >
                    <div className="row">
                        <div className="col-lg-12 colPadding margintop">


                            <Tabs activeKey={this.state.key} onSelect={this.handleSelect} style={{ 'pointer-events': 'none' }}
                                id="controlled-tab-example" className="KloShooping border-0">
                                <Tab eventKey={1} title={Title1} >
                                    {(() => {
                                        if (this.state.key == '1') {
                                            return (

                                                <div id="shoppingCart" className="mt-4" >
                                                    <p className="franziskafont">Shopping Cart</p>
                                                    <CartItem CartItem={this.state.CartItem} YourDetailsCallback={this.YourDetailsCallback.bind(this)} YourDetails={this.state.YourDetails} />
                                                    <div className="row my-5 ">
                                                        <div className="col"><a href="/"><button className="btn back-btn"><span className="oi oi-chevron-left pr-1"></span>Back to Kluwer Law Online</button></a></div>

                                                        <div className="col"><button id="btnproceedtocheckout" style={{'display':'none'}} className="btn btn-info next float-right" activeKey={this.state.key} onClick={() => this.handleSelect("2")}><span>Proceed to checkout</span><span className="oi oi-chevron-right pl-1"></span></button></div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    }
                                    )()}


                                </Tab>
                                <Tab eventKey={2} title={Title2} id="tab2" >
                                    {(() => {
                                        if (this.state.key == '2') {
                                            if (localStorage.getItem('user') !== null) {
                                                return (
                                                    <div id="yourDetails" className="mt-4 font-500">
                                                        <YourDetails YourDetailsCallback={this.YourDetailsCallback.bind(this)} YourDetails={this.state.YourDetails} />

                                                    </div>)
                                            }
                                            else {
                                                localStorage.setItem('redirecttocart','true')
                                                return <Redirect to={"/Login"} />
                                            } 
                                        }
                                    }
                                    )()}
                                </Tab>
                                <Tab eventKey={3} title={Title3} id="tab3" >
                                    {(() => {

                                        if (this.state.key == '3') {
                                            return (
                                                <div id="Review" className="mt-4">
                                                    <p className="franziskafont"> Review order</p>
                                                    <ReviewCartItem YourDetailsCallback={this.YourDetailsCallback.bind(this)} YourDetails={this.state.YourDetails} />

                                                </div>
                                            )
                                        }
                                    }
                                    )()}
                                </Tab>
                                <Tab eventKey={4} title={Title4} id="tab4" >
                                    {(() => {

                                        if (this.state.key == '4') {
                                            return (
                                                <MakePayment YourDetailsCallback={this.YourDetailsCallback.bind(this)} YourDetails={this.state.YourDetails} />
                                            )
                                        }
                                    }
                                    )()}


                                </Tab>

                            </Tabs>

                        </div>

                    </div>

                    </div>
                </DocumentMeta >
            );
        }



    }
}


// WEBPACK FOOTER //
// ./src/components/Shopping Cart/ShoppingCart.jsx